import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import useRouterStore from '../../../utils/hooks/useRouterStore';
import { useModalToastQueue } from '@/utils/hooks/useModalToastQueue.hook';

const EmailConfirmationPage = () => {
    const { push } = useRouterStore();
    const toast = useModalToastQueue();

    useEffect(() => {
        push('show.all');
        toast.success(<FormattedMessage defaultMessage="Votre adresse e-mail est validée !" />);
    }, [push]);

    return null;
};

export default EmailConfirmationPage;
